// extracted by mini-css-extract-plugin
export default {"container":"Markdown_container__iAKUL","context":"Markdown_context__m3Fkk"};